<script setup>
import EmailIcon from "vue-material-design-icons/EmailOutline";
import PhoneIcon from "vue-material-design-icons/Phone";
import InstagramIcon from "vue-material-design-icons/Instagram";
import YoutubeIcon from "vue-material-design-icons/Youtube";
import FacebookIcon from "vue-material-design-icons/Facebook";
import LinkedinIcon from "vue-material-design-icons/Linkedin";
</script>
<template>
  <footer>
    <div class="container">
      <div class="block">
        <a
          href="http://www.anpii.org.br/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            class="logo"
            src="../assets/images/logo-white.svg"
            alt="Anpii logo"
          />
        </a>
      </div>
      <div class="block">
        <div class="col-title">Contatos</div>
        <div class="icon">
          <PhoneIcon fillColor="#fff" />
          <a href="tel:(19) 9 8122-7687">(19) 9 8122-7687</a>
        </div>
        <div class="icon">
          <EmailIcon fillColor="#fff" />
          <a href="mailto:contato@anpii.org.br">contato@anpii.org.br</a>
        </div>
      </div>

      <div class="block">
        <div class="col-title">Redes sociais</div>
        <span>Siga-nos em nossas redes sociais.</span>
        <div class="icon mt-1">
          <a
            href="https://www.instagram.com/anpii_agro/"
            target="_blank"
            rel="noopener noreferrer"
            title="Instagram"
            class="social-media"
          >
            <InstagramIcon :size="28" fillColor="#fff" />
          </a>
          <a
            href="https://youtube.com/channel/UCr5KPRSx_6PiXZP4xeaL3DQ"
            target="_blank"
            rel="noopener noreferrer"
            title="Youtube"
            class="social-media"
          >
            <YoutubeIcon :size="28" fillColor="#fff" />
          </a>
          <a
            href="https://www.facebook.com/ANPIItransforma/"
            target="_blank"
            rel="noopener noreferrer"
            title="Facebook"
            class="social-media"
          >
            <FacebookIcon :size="28" fillColor="#fff" />
          </a>
          <a
            href="https://www.linkedin.com/company/anpii/?originalSubdomain=it"
            target="_blank"
            rel="noopener noreferrer"
            title="Linkedin"
            class="social-media"
          >
            <LinkedinIcon :size="28" fillColor="#fff" />
          </a>
        </div>
      </div>
      <div class="block">
        <div class="develop-holder">
          <span class="col-title">Desenvolvido por:</span>
          <div class="itens">
            <a
              href="https://5p2r.com.br/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="../assets/images/5p2r-white.svg" alt="5p2r logo" />
            </a>
            <div class="links">
              <a href="mailto:resultado@5p2r.com.br">resultado@5p2r.com.br</a>
              <a href="tel:(19) 9 8257-4102">(19) 9 8257-4102</a>
              <a href="tel:(11) 9 7466-7077">(11) 9 7466-7077</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dues">
      <span>Termos de uso | Política de privacidade</span>
      <span>ANPII © - Todos os direitos reservados</span>
    </div>
  </footer>
</template>
<style lang="scss" scoped>
footer {
  position: relative;
  width: 100vw;
  padding: 90px 0 0 0;
  background-color: #00884f;
  .container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
    justify-content: space-between;
    gap: 2em 2em;

    .block {
      position: relative;
      a {
        display: block;
        font-family: fontLight;
        font-size: 1em;
        color: #fff;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .col-title {
      position: relative;
      color: #97d955;
      font-family: fontBold;
      font-size: 1em;
      height: 32px;
      margin-bottom: 5px;
      text-transform: uppercase;
    }
    .col-subtitle {
      position: relative;
      color: #fff;
      font-family: fontRegular;
      font-size: 1.1em;
      min-height: 32px;
      margin-bottom: 15px;
      p {
        color: #fff;
        font-size: 1.1em;
      }
    }
    .icon {
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: fit-content;
      margin-bottom: 12px;
      gap: 10px;
      span {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .social-media {
        transition: transform 0.25s ease;
        &:hover {
          transform: translateY(-3px);
        }
      }
    }
  }
}

span {
  color: #fff;
  font-size: 1rem;
}

.logo {
  max-width: 250px;
  @media only screen and (max-width: 720px) {
    max-width: 180px;
  }
}

.develop-holder {
  position: relative;
  display: flex;
  flex-direction: column;
  width: fit-content;
  gap: 10px;
  .col-title {
    color: #fff !important;
  }
  .itens {
    position: relative;
    display: flex;
    justify-content: flex-start;
    vertical-align: top;
    gap: 10px;
    width: fit-content;
    .itens a,
    .itens img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      margin-top: 5px;
    }
    .links {
      margin-top: -5px;
      a {
        font-family: fontLight;
        font-size: 1rem;
        margin-bottom: 6px;
      }
    }
  }
}

.dues {
  position: relative;
  width: 100vw;
  padding: 1.5rem 0;
  background-color: #045f38;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 35px;
  span {
    font-family: fontLight;
    font-size: 1rem;
  }
}

@media screen and (max-width: 1159px) {
  .container {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)) !important;
  }
  .block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .col-title,
    .col-subtitle {
      width: 100%;
      text-align: center;
    }
  }
}
</style>
